import { render, staticRenderFns } from "./BasicReportTables.vue?vue&type=template&id=ac6a1f08&scoped=true"
import script from "./BasicReportTables.vue?vue&type=script&lang=js"
export * from "./BasicReportTables.vue?vue&type=script&lang=js"
import style0 from "./BasicReportTables.vue?vue&type=style&index=0&id=ac6a1f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6a1f08",
  null
  
)

export default component.exports